import React, { useMemo } from 'react';
import c from 'classnames';
import i18next from 'i18next';
import PropTypes from 'prop-types';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

// TODO: https://uncinc.monday.com/boards/970563066/pulses/5903654737
import CustomInlineMenu from '../../CustomInlineMenu';
import { SCREEN_WIDE } from '../../../config/constants';

import './style.scss';

const MOBILE_SCROLL_OFFSET = 125;
const DESKTOP_SCROLL_OFFSET = 154;

function mapChaptersToSections(chapters) {
  const sections = chapters
    .map((chapter) => chapter.sections)
    .reduce((curr, next) => [...curr, ...next]);

  return sections.map((section) => {
    const currentChapter = chapters.find((chapter) => (
      chapter.sections.map((s) => s.id).includes(section.id)
    ));

    return {
      ...section,
      chapter: {
        id: currentChapter.id,
        number: currentChapter.number,
        title: currentChapter.title,
      },
    };
  });
}

const AccordionMenuHeader = (props) => {
  const { items, children } = props;
  const { width } = useWindowDimensions();
  const scrollOffset = width <= SCREEN_WIDE ? MOBILE_SCROLL_OFFSET : DESKTOP_SCROLL_OFFSET;

  const classNames = c('AccordionMenu__Header');

  const sections = useMemo(() => {
    if (items.length === 0) {
      return;
    }

    return mapChaptersToSections(items);
  }, [items]);

  return (
    <div className={classNames}>
      <div className="AccordionMenu__Header__default body-bold">
        {i18next.t('components.accordion_menu.title')}
      </div>
      <CustomInlineMenu
        scrollToTopOffset={scrollOffset}
        items={sections.map(({ id, number, title, chapter }) => ({
          elementId: id,
          menuItemName: (
            <div className="AccordionMenu__Header__item">
              <strong className="body-bold truncate">
                {i18next.t('components.accordion_menu.header.chapter_title', { number: chapter.number, title: chapter.title })}
              </strong>
              <div className="body-small truncate">
                {i18next.t('components.accordion_menu.header.chapter_section_title', { number, title })}
              </div>
            </div>
          ),
        }))}
      />

      {/* This will contain the open/close toggle button */}
      {children}
    </div>
  );
};

AccordionMenuHeader.propTypes = {
  items: PropTypes.arrayOf(PropTypes.exact({
    id: PropTypes.string,
    number: PropTypes.number,
    title: PropTypes.string,
    sections: PropTypes.arrayOf(PropTypes.exact({
      id: PropTypes.string,
      number: PropTypes.string,
      title: PropTypes.string,
    })),
  })).isRequired,
  children: PropTypes.element.isRequired,
};

export default AccordionMenuHeader;
